<div class="row justify-content-center" style="overflow: hidden;">
    <div class="col-12 mt-4" style="max-width: 1600px;">

        <!-- PAGINATOR -->
        <div class="row justify-content-center pt-3 pb-3" style="margin-right: 0; margin-left: 0;
            border: 1px solid lightgray;">
            <div class="d-none d-md-inline col-4 text-start">
                <span style="font-size: small;">{{"CUSTOMER.TOTALRESULTS" | translate}}:
                    {{totalResults}}
                </span>
            </div>

            <div class="d-none d-md-inline col-4 text-center">
                <span style="font-size: small;">{{"CUSTOMER.OBJPERPAGE" | translate}}:
                    {{itemsPerPage}}
                </span>
            </div>

            <div class="col-6 col-sm-12 col-md-4 text-end">
                <span>
                    <button [disabled]="currentPageIndex == 1" class="btn btn-link me-2 p-0" (click)="prevPage()">
                        <i class="bi bi-caret-left"></i>
                    </button>
                    <span style="font-size: small;">{{"CUSTOMER.PAGE" | translate}} {{currentPageIndex}} {{"CUSTOMER.OF" | translate}}
                        {{lastPage}}
                    </span>
                    <button [disabled]="currentPageIndex == lastPage" class="btn btn-link ms-2 p-0" (click)="nextPage()">
                        <i class="bi bi-caret-right"></i>
                    </button>
                </span>
            </div>
        </div>
        <table mat-table [dataSource]="dataSource" matSort class="mat-table" style="border: 1px solid lightgray;">

            <!-- User -->
            <ng-container matColumnDef="user">
                <th class="text-center" mat-header-cell *matHeaderCellDef style="max-width: 100px; font-weight: bold;">
                    {{"CUSTOMER.USER" | translate}}
                </th>
                <td class="text-center" mat-cell *matCellDef="let element; let i = index" style="max-width: 100px;"
                    [ngStyle]="{'border-bottom': showLine(i) ? '1px solid lightgray' : 'none'}">
                    <ng-container *ngIf="showUser(i)">
                        {{ element.user.nickname }}
                        <span *ngIf="element.user.email" class="ms-2">
                            <i class="bi bi-info-circle" matTooltip="{{element.user.email}}"></i>
                        </span>
                    </ng-container>
                </td>
            </ng-container>

            <!-- System Title -->
            <ng-container matColumnDef="title">
                <th class="text-center" mat-header-cell *matHeaderCellDef style="max-width: 200px; font-weight: bold;">
                    {{"CUSTOMER.SYSTEMTITLE" | translate}}
                </th>
                <td class="text-center rowHover" mat-cell *matCellDef="let element" style="max-width: 200px;">
                    <span class="text-truncate">
                        {{ element.title }}
                    </span>
                    <span class="ms-2">
                        <i *ngIf="element.description != '' && element.description != null"
                            class="bi bi-info-circle" matTooltip="{{element.description}}"></i>
                    </span>
                </td>
            </ng-container>

            <!-- System Status -->
            <ng-container matColumnDef="status">
                <th class="text-center d-none d-md-table-cell" mat-header-cell *matHeaderCellDef mat-sort-header
                    style="max-width: 120px; font-weight: bold;">
                    {{"CUSTOMER.SYSTEMSTATUS" | translate}}
                </th>
                <td class="d-none d-md-table-cell rowHover" mat-cell *matCellDef="let element"
                    style="max-width: 120px;">
                    <i class="bi bi-circle-fill me-2" [ngStyle]="{'color': '#'+element.status.color}"></i>
                    {{ element.status.name }}
                </td>
            </ng-container>

            <!-- System Owner -->
            <ng-container matColumnDef="owner">
                <th class="text-center d-none d-lg-table-cell" mat-header-cell *matHeaderCellDef
                    style="max-width: 100px; font-weight: bold;">
                    {{"CUSTOMER.OWNER" | translate}}
                </th>
                <td mat-cell *matCellDef="let element" style="max-width: 100px;"
                    class="d-none d-lg-table-cell text-center rowHover">
                    <div class="truncate-text">
                        {{element.owner}}
                    </div>
                </td>
            </ng-container>

            <!-- Installer -->
            <ng-container matColumnDef="installer">
                <th class="text-center d-none d-lg-table-cell" mat-header-cell *matHeaderCellDef
                    style="max-width: 100px; font-weight: bold;">
                    {{"CUSTOMER.INSTALLER" | translate}}
                </th>
                <td mat-cell *matCellDef="let element" style="max-width: 100px;"
                    class="d-none d-lg-table-cell text-center rowHover">
                    {{ element.installer_companyname }}
                </td>
            </ng-container>

            <!-- Header & Rows -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr class="rowHover" mat-row *matRowDef="let row; columns: displayedColumns"
                (click)="goToSystem(row)">
            </tr>
        </table>
    </div>
</div>
